import http from 'axios';

export default {
    state: {
        users: {
            loading : false,
            value : []
        }
    },
    getters: {
       
    },
    mutations: {
       SET_USERS(state,{loading=false,value=[]}){
        state.users = {loading, value};
       }
    },
    actions: {



        async fetchUsers({ commit, rootState}){
            commit('SET_USERS',{loading:true});
            const {data} = await http.get('/api/user',{
                headers:{Authorization:rootState.auth.token}
            })

            commit('SET_USERS',{value:data})
            //TODO
        },

        async createUser({ commit, state, rootState },userData){
          
            const {data} = await http.post('/api/user' ,userData ,{
                headers:{Authorization:rootState.auth.token}
            })


            commit('SET_USERS',{
                value:state.users.value.concat(data)
            })
        },

        async deleteUser({ commit, state, rootState },ID){
            const loadingOn = state.users.value.map(el=>el._id==ID?{...el,loading:true}:el);
            commit('SET_USERS',{value:loadingOn});
            try {
                await http.delete(`/api/user/${ID}`,{
                    headers:{Authorization:rootState.auth.token}
                })
            } catch (error) {
                // reset the spinner and let the component report the failure
                commit('SET_USERS',{value:state.users.value.map(el=>el._id==ID?{...el,loading:false}:el)});
                throw error
            }

            commit('SET_USERS',{
                value:state.users.value.filter(el=>el._id !== ID)
            })
        },
    },
    namespaced: true
}